import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

const useAdmission = () => {
  const [admissionData, setAdmissionData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAdmissionData = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('admissions')
        .select('content, brochure_link, admission_link')
        .single();
      
      if (error) throw error;
      setAdmissionData(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const updateAdmissionData = async (updatedData) => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('admissions')
        .update(updatedData)
        .eq('id', 1);
      
      if (error) throw error;
      setAdmissionData(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmissionData();
  }, []);

  return {
    admissionData,
    loading,
    error,
    updateAdmissionData
  };
};

export default useAdmission;